import I18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const en = require('./locales/en/translations.json');

I18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: en,
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

I18n.languages = ['en'];
export default I18n;
